import React, { useState } from 'react'
import styled from '@emotion/styled'

import { colors } from 'Constants'

import { Flex, Base, Grid } from 'lese'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendar } from '@fortawesome/free-solid-svg-icons'

import RelativeTimeFormat from 'relative-time-format'
import en from 'relative-time-format/locale/en.json'
import { ModalStore } from 'Store'
import DateSelectorModal from 'Components/DateSelectorModal'

RelativeTimeFormat.addLocale(en)

const Container = styled(Flex)`
  border: 1px solid ${colors.borderColor};
  background-color: ${colors.background600};
  padding: 16px;
`

export default ({
  onChange,
  value: { startDate, endDate },
  onClose,
  color
}) => {
  if (!isNaN(startDate)) startDate = new Date(+startDate)
  if (!isNaN(endDate)) endDate = new Date(+endDate)

  let readableDate = ''
  if (!startDate && !endDate) readableDate = 'All Time'
  if (!startDate && endDate instanceof Date)
    readableDate = `All dates up until ${endDate.toUTCString().slice(0, 16)}`
  if (startDate instanceof Date && !endDate)
    readableDate = `${startDate.toUTCString().slice(0, 16)} until Present`
  if (startDate instanceof Date && endDate instanceof Date)
    readableDate = `${startDate
      .toUTCString()
      .slice(0, 16)} until ${endDate.toUTCString().slice(0, 16)}`

  const openModal = () =>
    ModalStore.set(state => ({
      components: [
        ...state.components,
        <DateSelectorModal
          value={{ startDate, endDate }}
          onChange={onChange}
          icon={faCalendar}
          onClose={onClose}
          color={color}
        />
      ]
    }))

  return (
    <Container column separation="16px">
      <Flex
        xAlign="space-between"
        style={{ cursor: 'pointer' }}
        onClick={openModal}
        separation="16px"
      >
        <Flex column separation="4px">
          <Base fontSize="0.8em">Showing data for</Base>
          <p>{readableDate}</p>
        </Flex>
        <FontAwesomeIcon
          icon={faCalendar}
          size="2x"
          color={color || colors.secondary}
        />
      </Flex>
    </Container>
  )
}
